import styled from "styled-components";
import {AppHeaderCrossBrandItemDefaultBox} from "./app-header-cross-brand-item.default.box";

export const AppHeaderCrossBrandItemMrgreenBox = styled(AppHeaderCrossBrandItemDefaultBox)`
  flex-direction: row;
  margin: 0 1.5rem;
  font-size: 1.4rem;
  height: 24px;
  color: ${props => props.menuItemKey === 'casinoCrossBrandMenuItem' ? props.theme.colors.backgroundLight : props.theme.colors.text};
  font-weight: ${props => props.menuItemKey === 'casinoCrossBrandMenuItem' ? 700 : 400};
`;
